import { Selector } from '@ngxs/store';
import { OnderwijslocatiesState } from '@store/states/onderwijslocaties.state';
import { OnderwijslocatiesStateModel } from '@store/models/onderwijslocaties.model';

export class OnderwijslocatiesSelectors {
  @Selector([OnderwijslocatiesState])
  static onderwijslocaties(state: OnderwijslocatiesStateModel) {
    return state.onderwijslocaties;
  }

  @Selector([OnderwijslocatiesState])
  static selectOnderwijslocatie(state: OnderwijslocatiesStateModel) {
    return state.selectOnderwijslocatie;
  }

  @Selector([OnderwijslocatiesState])
  static onderwijslocatiesLoading(state: OnderwijslocatiesStateModel) {
    return state.loading;
  }

  @Selector([OnderwijslocatiesState])
  static onderwijslocatiesLoaded(state: OnderwijslocatiesStateModel) {
    return state.loaded;
  }

  @Selector([OnderwijslocatiesState])
  static onderwijslocatiesError(state: OnderwijslocatiesStateModel) {
    return state.error;
  }
}
